import { module } from 'modujs';
import { html } from '../utils/environment';
import * as focusTrap from 'focus-trap';

export default class extends module {
    constructor(m) {
        super(m);

        // Binding
        this.onEscapeBind = (e) => {
            if (
                e.key === "Escape" &&
                this.el.classList.contains("is-active")
            ) {
                this.close();
            }
        };

        this.onCloseBind = this.close.bind(this)

        // UI
        this.$el = this.el
        this.$closeBtn = this.$('close')[0]
        this.$overlay = this.$('overlay')[0]

        // Inert
        this.trap = focusTrap.createFocusTrap(this.el);
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents();
    }

    destroy() {
        this.unbindEvents();
        super.destroy();
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        this.$overlay.addEventListener('click', this.onCloseBind)
        this.$closeBtn.addEventListener('click', this.onCloseBind)
        document.addEventListener('keyup', this.onEscapeBind)
    }

    unbindEvents() {
        this.$overlay.removeEventListener('click', this.onCloseBind)
        this.$closeBtn.removeEventListener('click', this.onCloseBind)
        document.removeEventListener('keyup', this.onEscapeBind)
    }

    ///////////////
    // Methods
    ///////////////

    // Display
    toggle() {
        if (html.classList.contains("has-modal-open")) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        html.classList.add("has-modal-open");
        this.$el.classList.add('is-active')

        setTimeout(() => {
            this.trap?.activate();
        }, 500)
    }

    close() {
        html.classList.remove("has-modal-open");
        this.$el.classList.remove('is-active')

        requestAnimationFrame(() => {
            this.trap?.deactivate();
        })
    }
}
